<template>
    <div id="app">
        <symbols />
        <transition name="fade">
            <router-view />
        </transition>
    </div>
</template>

<script>
import { getGyms } from '@/lib/backend';
import Symbols from '@/components/Symbols';
export default {
    components: {
        Symbols
    },
    data() {
        return {
            slideOrder: [
                {
                    name: 'prestaties'
                },
                {
                    name: 'groepslessen'
                }
            ],
            currentSlideNum: -1,
            vestigingId: +this.$route.query.vestiging,
            loop: this.$route.query.loop
        };
    },
    computed: {
        currentSlide() {
            return this.slideOrder[this.currentSlideNum];
        }
    },
    async created() {
        if (this.loop) {
            setTimeout(() => {
                this.nextSlide();
            }, 2500);
            this.$root.$on('cycle-finished', this.nextSlide);
        }
        if (this.vestigingId) {
            const gyms = await getGyms();
            const gym = gyms.find(gym => gym.id === +this.vestigingId);
            if (gym) {
                this.vestiging = { ...gym, naam: gym.name };
                this.$root.$data.vestiging = this.vestiging;
            }
        }
    },
    methods: {
        nextSlide() {
            if (this.currentSlideNum < this.slideOrder.length - 1) {
                this.currentSlideNum++;
            } else {
                this.currentSlideNum = 0;
            }
            this.$router.push(
                `${this.currentSlide.name}?vestiging=${this.vestigingId}`
            );
        }
    }
};
</script>

<style>
#app {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}
.fade-enter-active {
    transition-delay: 0.5s;
}
</style>
